import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import appErrorService from '../../services/app/appErrorService';
import uiMessageRequestService from '../../services/iot/uiMessageRequestService';
import {makeSelectIsYapFirmwareInProgress} from '../../state/selectors/yapEncrypted';
import {IFwuInfo} from './useFWUInfoLoaded';

interface IProps {
    fwuInfo?: IFwuInfo;
    forceCheck?: boolean;
    showGlobalError?: boolean;
}

const usePublishCheckFirmware = (props: IProps): void => {
    const {fwuInfo, forceCheck, showGlobalError} = props;
    const isYapFirmwareInProgress = useSelector(makeSelectIsYapFirmwareInProgress());
    const deps = forceCheck ? [] : [fwuInfo?.isLoaded, isYapFirmwareInProgress];

    const startCheck = async () => {
        const result = await uiMessageRequestService().publishCheckFirmwareMessage(fwuInfo!.fwuTarget);

        if (!result && showGlobalError) {
            appErrorService.showGlobalErrorWithAppReset();
        }
    };

    useEffect(() => {
        const isCheckingNeeded =
            fwuInfo && !fwuInfo.isAvailable && fwuInfo.fwuTarget && (!fwuInfo.isLoaded || forceCheck);

        if (isCheckingNeeded && !isYapFirmwareInProgress) {
            startCheck();
        }
    }, deps);
};

export default usePublishCheckFirmware;
